import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import VrrPayment from "./vrrpaymentlistview";
import { setBreadCrumb } from "../../../../store/userSlice";

export default function VrrIndex() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(setBreadCrumb([
      { label: "VRF_SUMMARY", link: `/dashboard/visa-request-form` },
      { label: "FINANCE_DESK - VRF / VRR PAYMENT" },
    ]));
  }, [location]);

  return (
    <div>
      <VrrPayment
        titles={[
          "S.NO", "VRF REFERENCE NUMBER", "VISA BLOCK NUMBER", "VISA PROVIDER",
          "AJEER", "SPONSOR ID", "NATIONALITY", "STAMP CITY",
          "IQAMA PROFESSION", "PRIORITY OF ISSUANCE", "TOTAL VISAS", "STATUS", "ACTION",
        ]}
      />
    </div>
  );
}
